import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

export function useLeadSubmit() {
  const [state, setState] = useState({ sending: false, ok: false, error: null });
  const reset = () => setState({ sending: false, ok: false, error: null });
  const submit = async (payload, onDone) => {
    setState({ sending: true, ok: false, error: null });
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/leads`, payload);
      setState({ sending: false, ok: true, error: null });
      onDone && onDone();
    } catch (e) {
      const detail = e.response?.data?.detail;
      const msg =
        typeof detail === "string"
          ? detail
          : "No se pudo enviar. Intente nuevamente o escríbanos por WhatsApp.";
      setState({ sending: false, ok: false, error: msg });
      toast.error(msg);
    }
  };
  return { ...state, submit, reset };
}
